import {
  Facebook as FacebookIcon,
  GitHub as GithHubIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
  Twitter as TwitterIcon,
  YouTube as YouTubeIcon,
} from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";

const SocialLinks = () => {
  return (
    <Box display="flex" justifyContent="space-between" color="var(--white)">
      <IconButton
        size="large"
        color="inherit"
        href="https://facebook.com/"
        target="_blank"
      >
        <FacebookIcon />
      </IconButton>
      {/* <IconButton
        size="large"
        color="inherit"
        href="https://www.youtube.com/channel/UCBSNbOumi5uNLJz8vFGJLRQ"
        target="_blank"
      >
        <YouTubeIcon />
      </IconButton> */}
      <IconButton
        size="large"
        color="inherit"
        href="https://www.instagram.com/mahmoud_kalekish/?igshid=YmMyMTA2M2Y%3D"
        target="_blank"
      >
        <InstagramIcon />
      </IconButton>
      <IconButton
        size="large"
        color="inherit"
        href="https://github.com/MahmoudKalekish"
        target="_blank"
      >
        <GithHubIcon />
      </IconButton>
      <IconButton
        size="large"
        color="inherit"
        href="https://www.linkedin.com/in/mahmoud-kalekish/"
        target="_blank"
      >
        <LinkedInIcon />
      </IconButton>
    </Box>
  );
};
export default SocialLinks;
